import { Component, OnInit } from '@angular/core';
import { UserService } from '../user/user.services';
import swal from 'sweetalert2';
@Component({
  selector: 'app-menu-privileges',
  templateUrl: './menu-privileges.component.html',
  styleUrls: ['./menu-privileges.component.scss']
})
export class MenuPrivilegesComponent implements OnInit {

  menuList:any[];
  selectedMenuList:any[];
  selectedPrivileges:any[];
  unSelectedMenuList:any=[];
  unSelectedPrivilageList:any=[];
  privilageList=[];
  subProfileId;
  profileId;
  searchPrivilage;
  searchMenu;
  constructor(private userService:UserService) { 
  

  
  }

  ngOnInit() {

    this.selectedMenuList = [];
    this.selectedPrivileges = [];

  }
  save(){
    let userPrvilages=[];
    for(let item of this.selectedPrivileges){
      let id={
        privilageId:item.privilageId? item.privilageId :item.id.privilageId,
        subProfileId:this.subProfileId,
      }
      let userPrivilage={
        profileId:this.profileId,
        id:id
      }
      userPrvilages.push(userPrivilage);
    }
    let userMenus=[];
    for(let item of this.selectedMenuList){
      let id={
        menuId: item.menuId ? item.menuId :item.id.menuId,
        subProfileId:this.subProfileId,
      }
      let userMenu={
       id:id
      }
      userMenus.push(userMenu);
      //find parent also and add
      /* let parentObject=this.menuList.filter(obj => obj.menuId===item.parentId)
      let pid={
        menuId: parentObject[0].menuId,
        subProfileId:this.subProfileId,
      }
      let parentMenu={
       id:pid
      }
      userMenus.push(parentMenu); */
    }

   

    this.userService.mapProfileMenu(userMenus).subscribe(response => {
      if (response && response["code"]==0) {
        this.selectedMenuList=response["result"];
        this.selectedMenuList = this.selectedMenuList.map(item => ({
          ...item,
          menuName: item.id.menuId ? this.menuList.find(obj => +obj.menuId === +item.id.menuId).menuName : null,
        })); 
      }else{
        swal.fire("Error", response['message'], 'error');
      }
    })

    this.userService.mapProfilePrivilage(userPrvilages).subscribe(response => {
      if (response && response["code"]==0) {
        this.selectedPrivileges=response["result"];
        this.selectedPrivileges = this.selectedPrivileges.map(item => ({
          ...item,
          privilageName: item.id.privilageId ? this.privilageList.find(obj => +obj.privilageId === +item.id.privilageId).privilageName : null,
        })); 
        swal.fire("Success", response['message'], 'success');
      }else{
        swal.fire("Error", response['message'], 'error');
      }
    })
    //console.log(this.selectedMenuList);
    //console.log(this.selectedPrivileges)
    
  }
  loadSelectedMenuAndPrivilage(secSubProId){
    this.selectedMenuList=[];
    this.selectedPrivileges=[];
    this.unSelectedMenuList=this.menuList;
    this.unSelectedPrivilageList=this.privilageList
    this.userService.getPrivilagesBySubProfileId(secSubProId).subscribe(response => {
      if(response['code']==='S0000'){
        this.selectedPrivileges=response['result'];
        this.selectedPrivileges = this.selectedPrivileges.map(item => ({
          ...item,
          privilageName: item.id.privilageId ? this.privilageList.find(obj => +obj.privilageId === +item.id.privilageId).privilageName : null,
        })); 
        this.unSelectedPrivilageList=this.minusRole(this.privilageList,this.selectedPrivileges);
      }
      
    })
    this.userService.getMenusBySubProfileId(secSubProId).subscribe(response => {
      if(response['code']==='S0000'){
        this.selectedMenuList=response['result'];
        this.selectedMenuList = this.selectedMenuList.map(item => ({
          ...item,
          menuName: item.id.menuId ? this.menuList.find(obj => +obj.menuId === +item.id.menuId).menuName : null,
        })); 
        this.unSelectedMenuList=this.minusMenu(this.menuList,this.selectedMenuList);
      }
      
    })
   
    
  }
  minusRole(firstArr: any = [], secondArr: any = []): any[] {
    let newListOfRole = {}
    secondArr.forEach(function (obj) {
      newListOfRole[obj.id.privilageId] = obj;
    });
    return firstArr.filter(function (obj) {
      return !(obj.privilageId in newListOfRole);
    });
  }
  minusMenu(firstArr: any = [], secondArr: any = []): any[] {
    let newListOfRole = {}
    secondArr.forEach(function (obj) {
      newListOfRole[obj.id.menuId] = obj;
    });
    return firstArr.filter(function (obj) {
      return !(obj.menuId in newListOfRole);
    });
  }
  reset(){

  }

}
